<template>
  <nav>
    <v-navigation-drawer
      v-model="drawer"
      app
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <Menu v-if="!hideToggle" />
    </v-navigation-drawer>

    <v-app-bar
      app
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="blue darken-3"
      dark
      fixed
    >
      <v-toolbar-title
        style="width: 450px"
        class="ml-0 pl-3"
      >
        <v-app-bar-nav-icon
          @click.stop="drawer = !drawer"
          v-if="!hideToggle"
        ></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">RA2S - Serviços de Telecomunicação Ltda.</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <UserDropdown v-if="!hideUserDropdown" />
    </v-app-bar>
  </nav>
</template>

<script>
import UserDropdown from './UserDropdown'
import Menu from './Menu'
export default {
  name: 'Header',
  components: { UserDropdown, Menu },
  props: {
    title: String,
    hideToggle: Boolean,
    hideUserDropdown: Boolean
  },
  data () {
    return {
      drawer: false
    }
  },
  computed: {
    icon () {
      return this.$store.state.isMenuVisible ? 'fa-angle-left' : 'fa-angle-down'
    }
  },
  methods: {
    toggleMenu () {
      this.$store.commit('toggleMenu')
    }
  }
}
</script>

<style scoped>
.app-bar {
  /* grid-area: header;
    display: flex;
    justify-content: center;
    align-items: center; */
  background: linear-gradient(to right, #1e469a, #49a7c1);
}

.title {
  font-size: 1.2rem;
  color: #fff;
  font-weight: 100;
  flex-grow: 1;
  text-align: left;
}

.title a {
  color: #fff;
  text-decoration: none;
}

.title a:hover {
  color: #fff;
  text-decoration: none;
}

header.header > a.toggle {
  width: 60px;
  height: 100%;
  color: #fff;
  justify-self: flex-start;
  text-decoration: none;

  display: flex;
  justify-content: center;
  align-items: center;
}

header.header > a.toggle:hover {
  color: #fff;
  background-color: rgba(0, 0, 0, 0.2);
}
</style>
